<div class="row">
  <div class="col-12">
    <div class="header mt-md-5">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">

            <!-- Pretitle -->
            <h6 class="header-pretitle">
              Vue d'ensemble
            </h6>

            <!-- Title -->
            <h1 class="header-title">
              {{ this.organizationName }}
            </h1>

          </div>
        </div> <!-- / .row -->
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-alert-messages></app-alert-messages>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-10 col-xl-8">
        <app-timeline></app-timeline>
      </div>
    </div>

    <!--        <div class="row">-->
    <!--            <div class="col-12 col-lg-10 col-xl-8">-->
    <!--                <div class="row">-->
    <!--                    <div class="col-12">-->
    <!--                        <div class="card">-->
    <!--                            <div class="card-header">-->
    <!--                                <div class="row align-items-center">-->
    <!--                                    <div class="col">-->

    <!--                                        &lt;!&ndash; Title &ndash;&gt;-->
    <!--                                        <h4 class="card-header-title">-->
    <!--                                            Mandats récents-->
    <!--                                        </h4>-->

    <!--                                    </div>-->
    <!--                                    <div class="col-auto">-->

    <!--                                        &lt;!&ndash; Button &ndash;&gt;-->
    <!--                                        <a class="btn btn-sm btn-primary" routerLink="/mandates/create">-->
    <!--                                            Créer un nouveau mandat-->
    <!--                                        </a>-->

    <!--                                    </div>-->
    <!--                                </div>-->
    <!--                            </div>-->
    <!--                            <div class="table-responsive">-->
    <!--                                <table class="table table-sm table-nowrap card-table">-->
    <!--                                    <thead>-->
    <!--                                    <tr>-->
    <!--                                        <th>Nom du client</th>-->
    <!--                                        <th>Calcul</th>-->
    <!--                                        <th>Dernière modification</th>-->
    <!--                                        <th>Statut de l'étude</th>-->
    <!--                                        <th></th>-->
    <!--                                    </tr>-->
    <!--                                    </thead>-->
    <!--                                    <tbody class="fs-base">-->
    <!--                                    <tr *ngFor="let recentMandate of this.recentMandates">-->
    <!--                                        <td>-->
    <!--                                            <a href="invoice.html">{{ recentMandate.clientName }}</a>-->
    <!--                                        </td>-->
    <!--                                        <td>-->
    <!--                                            {{ recentMandate.calculationName }}-->
    <!--                                        </td>-->
    <!--                                        <td>-->
    <!--                                            <time datetime="2020-04-24">{{ recentMandate.getDateLabel() }}</time>-->
    <!--                                        </td>-->
    <!--                                        <td>-->
    <!--                                            <span class="badge"-->
    <!--                                                  [ngClass]="recentMandate.statusClass">{{ recentMandate.statusTitle }}</span>-->
    <!--                                        </td>-->
    <!--                                        <td>-->
    <!--                                            <div class="col-auto">-->

    <!--                                                &lt;!&ndash; Dropdown &ndash;&gt;-->
    <!--                                                <div class="dropdown">-->
    <!--                                                    <a class="dropdown-ellipses dropdown-toggle" href="#" role="button"-->
    <!--                                                       data-bs-toggle="dropdown" aria-haspopup="true"-->
    <!--                                                       aria-expanded="false">-->
    <!--                                                        <i class="fe fe-more-vertical"></i>-->
    <!--                                                    </a>-->
    <!--                                                    <div class="dropdown-menu dropdown-menu-end">-->
    <!--                                                        <a class="dropdown-item" href="#!">-->
    <!--                                                            Action-->
    <!--                                                        </a>-->
    <!--                                                        <a class="dropdown-item" href="#!">-->
    <!--                                                            Another action-->
    <!--                                                        </a>-->
    <!--                                                        <a class="dropdown-item" href="#!">-->
    <!--                                                            Something else here-->
    <!--                                                        </a>-->
    <!--                                                    </div>-->
    <!--                                                </div>-->

    <!--                                            </div>-->
    <!--                                        </td>-->
    <!--                                    </tr>-->

    <!--                                    </tbody>-->
    <!--                                </table>-->
    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->

    <!--            <div class="col-12 col-lg-2 col-xl-4">-->
    <!--                <div class="card">-->
    <!--                    <div class="card-header">-->
    <!--                        <div class="row align-items-center">-->
    <!--                            <div class="col">-->

    <!--                                &lt;!&ndash; Title &ndash;&gt;-->
    <!--                                <h4 class="card-header-title">-->
    <!--                                    Nouvelles-->
    <!--                                </h4>-->

    <!--                            </div>-->
    <!--                            <div class="col-auto">-->

    <!--                                &lt;!&ndash; Dropdown &ndash;&gt;-->
    <!--                                <div class="dropdown">-->
    <!--                                    <a class="dropdown-ellipses dropdown-toggle" href="#" role="button"-->
    <!--                                       data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
    <!--                                        <i class="fe fe-more-vertical"></i>-->
    <!--                                    </a>-->
    <!--                                    <div class="dropdown-menu dropdown-menu-end">-->
    <!--                                        <a class="dropdown-item" href="#!">-->
    <!--                                            Action-->
    <!--                                        </a>-->
    <!--                                        <a class="dropdown-item" href="#!">-->
    <!--                                            Another action-->
    <!--                                        </a>-->
    <!--                                        <a class="dropdown-item" href="#!">-->
    <!--                                            Something else here-->
    <!--                                        </a>-->
    <!--                                    </div>-->
    <!--                                </div>-->

    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </div>-->

    <!--                    <div class="card-body">-->
    <!--                        <div class="row" *ngFor="let value of news">-->
    <!--                            <div class="col-12">-->
    <!--                                <a class="card" routerLink="/account/general">-->

    <!--                                    &lt;!&ndash; Image  &ndash;&gt;-->
    <!--                                    <img class="card-img-top" [src]="value.imageUrl" *ngIf="value.imageUrl">-->

    <!--                                    &lt;!&ndash; Body &ndash;&gt;-->
    <!--                                    <div class="card-body">-->
    <!--                                        <div class="row align-items-center">-->
    <!--                                            <h3>{{ value.title }}</h3>-->

    <!--                                            &lt;!&ndash; Badge &ndash;&gt;-->
    <!--                                            <span class="badge bg-success-soft" *ngIf="value.badgeTitle">-->
    <!--                                                {{ value.badgeTitle }}-->
    <!--                                            </span>-->

    <!--                                            &lt;!&ndash; Price &ndash;&gt;-->
    <!--                                            <small class="text-muted">-->
    <!--                                                <i class="fal fa-clock"></i>-->
    <!--                                                {{ value.getDateLabel() }}-->
    <!--                                            </small>-->

    <!--                                        </div> &lt;!&ndash; / .row &ndash;&gt;-->
    <!--                                    </div>-->


    <!--                                </a>-->
    <!--                            </div>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </div>-->

    <!--            </div>-->

    <!--        </div>-->
  </div>
</div>
